import { z } from 'zod';

/** Attribution only: possession of this code never authorizes account access. */
export const CrmRefSchema = z.string().regex(/^[A-Za-z0-9_-]{32}$/);

/** null records rejected attribution without retaining attacker-controlled input. */
export const SignupCrmRefSchema = CrmRefSchema.nullable().catch(null).optional();

export const CrmRegistrationEventSchema = z.object({
  event_id: z.string().uuid(),
  cabinet_id: z.string().uuid(),
  user_id: z.string().uuid(),
  crm_ref: CrmRefSchema,
  occurred_at: z.string().datetime({ offset: true }),
  creator_email: z.string().email().max(320),
}).strict();
export type CrmRegistrationEvent = z.infer<typeof CrmRegistrationEventSchema>;
